import { render } from "./Automatic.vue?vue&type=template&id=69f25fa6&scoped=true"
import script from "./Automatic.vue?vue&type=script&lang=js"
export * from "./Automatic.vue?vue&type=script&lang=js"

import "./Automatic.vue?vue&type=style&index=0&id=69f25fa6&scoped=true&lang=scss"

import exportComponent from "E:\\work\\project_4\\核验\\heyan\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69f25fa6"]])

export default __exports__